import React, {Fragment} from "react";
import Button from "./Button";
import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import PropsProxy from "../layout/PropsProxy";

export const deleteProps: Partial<ConfirmProps> = {
    header: "Törlés",
    body: "Biztosan törlöd ezt a tételt?",
    acceptButton: "Törlés",
    color: "danger",
    button: "Törlés",
    timeout: 3,
}

export const smallDeleteProps: Partial<ConfirmProps> = {
    ...deleteProps,
    button: null,
    icon: {lib: "fa", name: "trash"},
    buttonSize: "xs",
}

type ConfirmProps = {
    cancelButton?: any,
    acceptButton?: any,
    size?: "large"|"medium"|"small",
    buttonSize?: string,
    timeout?: number,
    header?: any,
    body?: any,
    button?: any,
    color?: string,
    theme?: string,
    container?: any,
    footer?: any,
    isLoading?: boolean,
    valid?: boolean|(() => boolean),
    disabled?: true|false|"true"|"false"|"disabled",
    onCancel?: (e: Event) => any,
    onAccept: (e: Event) => any,
    acceptAble?: boolean,
    [otherProp: string]: any,
};

type ConfirmState = {
    progress?: boolean,
    confirm?: boolean
}

// <Confirm
//     key="2"
//     disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
//     color="danger"
//     className="pull-left"
//     onAccept={() => this.props.processAction(async ({componentAction}) => await componentAction('storno'))}
//     header="Biztos?"
//     body="Blabla"
// >
//     Sztornó
// </Confirm>
export default class Confirm extends React.Component<ConfirmProps, ConfirmState> {

    static defaultProps = {
        acceptAble: true
    }

    state = {
        progress: false,
        confirm: false
    }

    onCancel = async (e: any) => {
        try {
            this.setState({progress: true});
            this.props.onCancel && await this.props.onCancel(e);
        } catch (e) {
            console.log(e);
        }
        this.setState({confirm: false, progress: false});
    }

    onAccept = async (e: any) => {
        try {
            this.setState({progress: true});
            await this.props.onAccept(e);
        } catch (e) {
            console.log(e);
        }
        this.setState({progress: false, confirm: false});
    }

    render() {
        let button;
        if (!this.props.children || typeof(this.props.children) === "string") {
            const buttonProps: ConfirmProps = {...this.props};
            delete buttonProps.timeout;
            delete buttonProps.onAccept;
            delete buttonProps.acceptAble;
            delete buttonProps.acceptButton;
            delete buttonProps.buttonSize;
            button = <Button
                {...buttonProps}
                size={this.props.buttonSize}
            >
                {this.props.children || this.props.button}
            </Button>
        } else {
            button = this.props.children;
        }
        return (
            <Fragment>
                {this.state.confirm && <Modal
                    header={this.props.header}
                    state={this.state.confirm}
                    closeAble={!this.state.progress}
                    size={this.props.size}
                    theme={this.props.theme}
                    container={this.props.container || Portal}
                    footer={this.props.footer}
                    buttons={[
                        {
                            text: this.props.cancelButton || "Mégse",
                            onClose: true,
                            props: {
                                color: this.props.theme || "default",
                                disabled: Boolean(this.props.disabled || this.props.isLoading || this.state.progress)
                            },
                            onClick: this.onCancel
                        },
                        {
                            text: this.props.acceptButton || "Mehet",
                            props: {
                                timeout: this.props.timeout,
                                color: this.props.color || "primary",
                                disabled: Boolean(this.props.acceptAble !== true || this.props.disabled || this.props.isLoading || this.state.progress)
                            },
                            onClick: this.onAccept
                        }
                    ]}
                >
                    {this.props.body}
                </Modal>}
                <PropsProxy
                    disabled={this.props.disabled || this.props.isLoading || this.state.progress}
                    onClick={async (e: any) => {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                        if (this.props.disabled || this.props.isLoading || this.state.progress) return false;
                        let valid: (() => boolean) | boolean = false;
                        if (this.props.valid) {
                            valid = this.props.valid instanceof Function ? this.props.valid() : this.props.valid;
                        }
                        if (!valid) {
                            this.setState({confirm: true});
                        } else {
                            await this.onAccept(e);
                        }
                    }}
                >
                    {button}
                </PropsProxy>
            </Fragment>
        );
    }
}